import { Component } from '@angular/core';
import { environment } from 'apps/cinema1/src/environments/environment';
import { OrderSummaryComponent } from 'libs/shared/src/lib/component/order/order-summary/order-summary.component';

@Component({ standalone: false, selector: 'app-order-order-summary', templateUrl: './order-summary.component.html' })
export class CustomOrderSummaryComponent extends OrderSummaryComponent {
  env = environment;
}
